import { experimental_extendTheme as extendTheme } from '@mui/material/styles';
const callVar = (varName: string) => {
  return getComputedStyle(document.documentElement).getPropertyValue(varName);
};

export const GlobalTheme = extendTheme({
  colorSchemes: {
    light: {
      palette: {
        primary: {
          main: `rgba(${callVar('--primary-code')})`,
        },
        secondary: {
          main: `rgba(${callVar('--secondary-code')})`,
        },
        error: {
          main: `rgba(${callVar('--error-code')})`,
        },
        success: {
          main: `rgba(${callVar('--success-code')})`,
        },
        warning: {
          main: `rgba(${callVar('--warning-code')})`,
        },
        info: {
          main: `rgba(${callVar('--info-code')})`,
        },
      },
    },
    dark: {
      palette: {
        primary: {
          main: `rgba(${callVar('--primary-code')})`,
        },
        secondary: {
          main: `rgba(${callVar('--secondary-code')})`,
        },
        error: {
          main: `rgba(${callVar('--error-code')})`,
        },
        success: {
          main: `rgba(${callVar('--success-code')})`,
        },
        warning: {
          main: `rgba(${callVar('--warning-code')})`,
        },
        info: {
          main: `rgba(${callVar('--info-code')})`,
        },
      },
    },
  },
  typography: {
    fontFamily: `${callVar('--font-family')}`,
  },
  components: {
    //  ------------------------------------FORM LABEL
    MuiFormLabel: {
      styleOverrides: {
        root: {
          fontSize: 12,
          fontWeight: 500,
        },
      },
    },
    // // ------------------------------------General buttons
    MuiButton: {
      styleOverrides: {
        root: {
          fontSize: 12,
          fontWeight: 600,
        },
        contained: {
          border: 'none',
        },
      },
    },
    MuiButtonBase: {
      styleOverrides: {
        root: {
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontWeight: 600,
        },
      },
    },
    // ------------------------------------Form Select
    MuiSelect: {
      styleOverrides: {
        select: {
          fontSize: 12,
          fontWeight: 500,
          display: 'flex',
          alignItems: 'center',
        },
      },
    },
    // ------------------------------------TextField

    // // ------------------------------------Form Select Dropdown Option
    MuiMenuItem: {
      styleOverrides: {
        root: {
          fontSize: 12,
        },
      },
    },
    // // ------------------------------------Form Input
    MuiInputBase: {
      styleOverrides: {
        input: {
          fontSize: 12,
          color: 'var(--black08) !important',
        },
      },
    },
    MuiInput: {
      styleOverrides: {
        root: {
          '&:before': {
            borderBottom: '1px solid var(--black01)',
          },
        },
      },
    },
    //  -------------------------------------------- ToolTip
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          fontSize: 12,
          cursor: 'pointer',
        },
      },
    },
    // ---------------------------------------Toggle Buttons
    MuiToggleButton: {
      styleOverrides: {
        root: {
          fontSize: 12,
          fontWeight: 600,
          padding: 0,
        },
      },
    },
    // -------------------------------------Data Grid Pro
    // MuiDataGrid: {
    //   styleOverrides: {
    //     root: {
    //       borderRadius: 10,
    //       overflow: "hidden",
    //       border: "1px solid var(--black01) !important",
    //       fontWeight: 500,
    //     },
    //     main: {
    //       boxShadow: "0px 5px 15px var(--black005)",
    //     },
    //     footerContainer: {
    //       borderBottomLeftRadius: 10,
    //       borderBottomRightRadius: 10,
    //     },
    //     columnHeaders: {
    //       backgroundColor: "var(--black04)",
    //       color: "var(--white)",
    //       fontSize: 14,
    //       boxShadow: "5px 5px 10px var(--black02)",
    //       borderTopLeftRadius: 10,
    //       borderTopRightRadius: 10,
    //     },
    //     columnHeaderTitle: {
    //       fontWeight: "bold",
    //     },
    //     row: {
    //       // -------------------------------Style selected rows
    //       "&.row-odd.Mui-selected": {
    //         backgroundColor: "var(--primary01)",
    //       },
    //       "&.row-even.Mui-selected": {
    //         backgroundColor: "var(--primary02)",
    //       },
    //       // -------------------------------Style hover row
    //       "&:hover": {
    //         backgroundColor: "var(--black01)",
    //       },
    //       "&.bold-text": {
    //         fontWeight: "600",
    //       },
    //     },
    //   },
    // },
  },
});
